"use strict";

exports.__esModule = true;
exports["default"] = exports.setRef = void 0;

var setRef = function setRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (ref) {
    // eslint-disable-next-line no-param-reassign
    ref.current = node;
  }
};

exports.setRef = setRef;

var mergeRefs = function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    return refs.forEach(function (ref) {
      return setRef(ref, node);
    });
  };
};

var _default = mergeRefs;
exports["default"] = _default;